import React from 'react';
import BatchOneTemplate from './BatchOneTemplate';
import BatchTwoTemplate from './BatchTwoTemplate';
import BatchThreeTemplate from './BatchThreeTemplate';
import BatchFourTemplate from './BatchFourTemplate';
import DefaultTemplate from './DefaultTemplate';
import FormulaV1Template from './FormulaV1Template';
import FormulaV2Template from './FormulaV2Template';

// Template legacy per-batch (formula v1, batch 1-4). Dipertahankan sebagai
// fallback selama admin belum mengonfigurasi logo/tanggal/TTD batch tersebut
// lewat halaman manajemen template -- supaya PDF batch lama tidak berubah
// tampilannya sebelum config baru diisi.
const LEGACY_TEMPLATE_MAP = {
  1: BatchOneTemplate,
  2: BatchTwoTemplate,
  3: BatchThreeTemplate,
  4: BatchFourTemplate,
};

const EvaluationDocumentResolver = ({ data, batchId }) => {
  const currentBatchId = batchId || data?.batchId;
  const formulaVersion = data?.formulaVersion;
  const hasCustomLogos = Boolean(data?.documentTemplate?.evalLogos?.length);

  let SelectedTemplate;

  if (formulaVersion === 'v2') {
    SelectedTemplate = FormulaV2Template;
  } else if (!hasCustomLogos && LEGACY_TEMPLATE_MAP[currentBatchId]) {
    SelectedTemplate = LEGACY_TEMPLATE_MAP[currentBatchId];
  } else if (formulaVersion === 'v1' || LEGACY_TEMPLATE_MAP[currentBatchId]) {
    SelectedTemplate = FormulaV1Template;
  } else {
    SelectedTemplate = DefaultTemplate;
  }

  return <SelectedTemplate finalEvaluation={data} />;
};

export default EvaluationDocumentResolver;
